import { useEffect, useState } from 'react';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import Lights from './Lights.jsx';
import Hotel from './component/Hotel.jsx';
import Player from './component/Player.jsx';
// import { OrbitControls} from "@react-three/drei";

export default function Experience() {
  const [hotelModel, setHotelModel] = useState(null);
  const [isModelLoaded, setIsModelLoaded] = useState(false);

  useEffect(() => {
    let loadedModel; // Separate variable to capture the loaded model
    const loader = new GLTFLoader();
    loader.load('./hallway.glb', (gltf) => {
      loadedModel = gltf;
      setHotelModel(gltf);
      setIsModelLoaded(true);
    });
  }, []);


  return (
    <>
            {/* <OrbitControls makeDefault/> */}
      <Lights />
      {isModelLoaded && <Hotel hotel={hotelModel} />}
      {isModelLoaded && <Player />}
    </>
  );
}
